import { Accordion } from '@liveauctioneers/hammer-ui-core/accordion';
import { CurrentOpenMenu } from '@/pages/SearchPageSimplified/types';
import { FilterAction } from '@/types/SearchFacet';
import { modifyParamsRemovePage, modifyParamsWithFilterTerm, parseQueryParams } from '@/utils/queryParams';
import { SearchFilterChips } from '@/pages/SearchPageSimplified/components/SearchPageTabs/components/SearchFilterChips/SearchFilterChips';
import { SearchInput } from '@liveauctioneers/hammer-ui-core/searchInput';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { useLocation } from 'react-router-dom';
import { useNavigateSearchPageWithParams } from '@/pages/SearchPageSimplified/hooks/useNavigateSearchPageWithParams';
import { useRef, useState } from 'react';

type Props = {
    isAllFilters?: boolean;
};

export const KeywordFilter = ({ isAllFilters }: Props) => {
    const { search } = useLocation();
    const queryParams = parseQueryParams(search);

    const [newKeywordValue, setNewKeywordValue] = useState('');

    const inputRef = useRef<HTMLInputElement>(null);

    const { formatMessage } = useIntl();

    const navigateWithParams = useNavigateSearchPageWithParams();

    const submitFilterTerm = (searchString: string) => {
        let newParams = modifyParamsWithFilterTerm(queryParams, searchString);
        newParams = modifyParamsRemovePage(newParams);

        navigateWithParams({
            checkForPageRemoval: true,
            currentOpenMenu: isAllFilters ? CurrentOpenMenu.AllFilters : undefined,
            filterAction: FilterAction.FilterTermAdded,
            params: newParams,
            preventScrollReset: true,
        });
    };

    const mainContent = (
        <>
            <SearchInput
                aria-label={formatMessage({
                    id: 'ariaLabel.searchInput',
                })}
                className="min-w-[246px]"
                inputRef={inputRef}
                onClear={() => {
                    setNewKeywordValue('');
                }}
                onSubmit={(searchTerm: string) => {
                    submitFilterTerm(searchTerm);
                    setNewKeywordValue('');
                }}
                onTextChange={(searchString: string) => {
                    setNewKeywordValue(searchString);
                }}
                placeholder={formatMessage({
                    id: 'filter_by_keyword',
                })}
                small={!isAllFilters}
                value={newKeywordValue}
            />
        </>
    );

    if (isAllFilters) {
        return (
            <Accordion
                className="w-full"
                density="compact"
                emphasis="prominent"
                headline={formatMessage({ id: 'filter_by_keyword' })}
                open
            >
                <div>
                    {mainContent}
                    <SearchFilterChips isAllFilters />
                </div>
            </Accordion>
        );
    }

    return mainContent;
};
